import { render, staticRenderFns } from "./DatatableEntityPacks.vue?vue&type=template&id=4ae06d4f"
import script from "./DatatableEntityPacks.vue?vue&type=script&lang=js"
export * from "./DatatableEntityPacks.vue?vue&type=script&lang=js"
import style0 from "./DatatableEntityPacks.vue?vue&type=style&index=0&id=4ae06d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports